import { OrgAppConfig } from "./bootstrap.model";

/** The value of a config: the JSON its column holds, read back; the text itself when it is not JSON; null when it has none. */
export function configValueOf(config: OrgAppConfig | undefined): unknown {
    if (!config?.value) return null;
    try {
        return JSON.parse(config.value);
    } catch {
        return config.value;
    }
}

/** The units a config turns on (`{"kg": true, "lt": true}`), or `defaults` when it is off or turns none on. */
export function enabledUnitsOf(config: OrgAppConfig | undefined, defaults: string[]): string[] {
    const value = config?.enabled ? configValueOf(config) : null;
    if (!value || typeof value !== "object") return defaults;
    const units = Object.entries(value as Record<string, unknown>)
        .filter(([, enabled]) => enabled === true)
        .map(([unit]) => unit);
    return units.length ? units : defaults;
}
